import script from "./SelectionDetailsItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectionDetailsItem.vue?vue&type=script&setup=true&lang=ts"

import "./SelectionDetailsItem.vue?vue&type=style&index=0&id=40cd6def&lang=scss"

const __exports__ = script;

export default __exports__